export default {
    UPDATE_NAME_PAGE(state, name) {
        state.namePage = name
    },
}